<section class="rs-es-first-section">
  <mprd-back-link></mprd-back-link>
  <div class="row">
    <div class="columns small-12">
      <h1 class="rs-txt-c2">
        {{ "modem-choice.title" | translate }}
      </h1>
      <div class="rs-panel-big rs-bg-c2 clearfix">
        <ng-container *ngIf="line; else lineLoading">
          <mprd-modem-choice-onts
            *ngIf="line.devices"
            [line]="line"
            (addModalOpened)="onAddOntModalOpened()"
            (editModalOpened)="onEditOntModalOpened($event)"
            (deleteModalOpened)="onDeleteOntModalOpened($event)"
            (activated)="onEditedOnt($event)"
          ></mprd-modem-choice-onts>
          <mprd-modem-choice-vlan
            [line]="line"
            (updated)="onUpdatedVlan($event)"
          ></mprd-modem-choice-vlan>
          <mprd-modem-choice-add-ont
            [line]="line"
            [(open)]="addOntModalOpen"
            (added)="onAddedOnt($event)"
          ></mprd-modem-choice-add-ont>
          <mprd-modem-choice-edit-ont
            [line]="line"
            [ncName]="selectedNcName"
            [(open)]="editOntModalOpen"
            (edited)="onEditedOnt($event)"
          ></mprd-modem-choice-edit-ont>
          <mprd-modem-choice-delete-ont
            [line]="line"
            [ncName]="selectedNcName"
            [(open)]="deleteOntModalOpen"
            (deleted)="onDeletedOnt($event)"
          ></mprd-modem-choice-delete-ont>
        </ng-container>
        <ng-template #lineLoading>
          <mprd-modem-choice-onts-skeleton></mprd-modem-choice-onts-skeleton>
          <mprd-modem-choice-vlan-skeleton></mprd-modem-choice-vlan-skeleton>
        </ng-template>
        <ng-container
          *ngIf="
            voipSubscriberNumbers$ | async as subscriberNumbers;
            else voipLoading
          "
        >
          <mprd-modem-choice-voip
            *ngIf="subscriberNumbers.length > 0"
            [subscriberNumbers]="subscriberNumbers"
            (voipCrendentialsModalOpened)="onVoipCredentialsModalOpened($event)"
          ></mprd-modem-choice-voip>
          <mprd-modem-choice-voip-credentials
            [subscriberNumber]="selectedSubscriberNumber"
            [(open)]="voipCredentialsModalOpen"
          ></mprd-modem-choice-voip-credentials>
        </ng-container>
        <ng-template #voipLoading>
          <mprd-modem-choice-voip-skeleton></mprd-modem-choice-voip-skeleton>
        </ng-template>
      </div>
      <div class="rs-le2"></div>
    </div>
  </div>
</section>
